<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 p-1 ">
      <h2 class="mb-0 main-title">Templates</h2>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-md btn-primary fs-11 fw-normal text-white" @click="openCreateModal('createModal')">
          Add New Template
        </button>
        <button type="button" class="btn btn-md btn-outline-primary fs-11 fw-normal text-primary hover-white"> <i
            class="fa fa-list fs-11 text-primary hover-white "></i> Templates List</button>
      </div>
    </div>
    <!-- Sirf Filters Bar -->
    <div class="filters-wrapper">
      <div class="filters-bar" id="filtersBar"></div>
      <button @click="resetAllFilters" class="btn btn-sm btn-outline-danger reset-btn fs-12 hover-white">
        <span class="material-symbols-outlined fs-13">undo</span> Reset
      </button>
    </div>

    <!-- Dropdown Template -->
    <div id="genericFilterDropdownTemplate" style="display: none;">
      <div class="generic-filter-dropdown">
        <div class="dropdown-header">
          <input type="text" class="filter-search-input" placeholder="Search...">
        </div>
        <div class="dropdown-body filter-options-container"></div>
        <div class="dropdown-footer">
          <button class="filter-clear-btn">Clear</button>
          <button class="filter-apply-btn">Apply</button>
        </div>
      </div>
    </div>
    <div class="card p-1 bg-white">


      <!-- Modal with CreateTemplate inside slot -->
      <FormModal ref="createModal" title="Create New Template" id="create_template_form_modal">
        <CreateTemplate @click="f" ref="CreateTemplateForm" @created="onCreated" @close="closeCreateModal('createModal')" />
      </FormModal>


      <!-- Loading State -->
      <LoadingBar v-if="loading" message="Loading templates..." />

      <!-- templates Table -->
      <div v-else class="table-wrapper ">
        <ListTable>
          <thead>
            <tr>
              <th @click="sortBy('name')" class="sortable">
                 Template <i :class="getSortIcon('external_id')"></i>
              </th>
              
              
               <th @click="sortBy('description')" class="sortable">
                Description <i :class="getSortIcon('description')"></i>
              </th>
              <th @click="sortBy('created_at')" class="sortable">
                Created At <i :class="getSortIcon('created_at')"></i>
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="template in templates" :key="template.external_id">
              <td>
                 <div class="mb-0">
                {{ template.name }}
              </div>
              <div class="mt-0">
                <small class="text-muted">#{{ template.doc_no }}</small>
              </div>
              </td>
              <td>{{ $limit(template.description, 40, '...') }}</td>
              <td>{{ template.created_at }}</td>
              <td>
                <div class="dropdown">
                  <button class="btn btn-sm  " type="button" id="actionMenuButton" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    <i class="fas fa-ellipsis-v"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="actionMenuButton">
                    <li><button class="dropdown-item" @click="$router.push(`/template/builder/${template.external_id}`)">
                      Builder
                    </button></li>
                    <li><button class="dropdown-item" @click="$router.push(`/template/edit/${template.external_id}`)">
                      Edit
                    </button></li>
                    <li><button class="dropdown-item text-danger" @click="deleteTemplate(template.external_id)">
                      Delete
                    </button></li>
                  </ul>
                </div>

              </td>
            </tr>
            <tr v-if="templates.length === 0">
              <td colspan="5" class="text-center">No Templates found</td>
            </tr>

          </tbody>
        </ListTable>
        
      </div>

      <!-- Pagination -->
      <Pagination :pagination="pagination" @page-change="changePage" />

    </div>
  </div>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import Pagination from '@/components/utils/PaginationBar.vue'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateTemplate from '@/views/Template/CreateTemplate.vue'
import ListTable from '@/components/utils/ListTable.vue'

export default {
  name: 'templateList',
  components: {
    Pagination,
    LoadingBar,
    FormModal,
    CreateTemplate,
    ListTable
  },
  data() {
    return {
      templates: [],
      pagination: {
        total_rows: 0,
        per_page: 20,
        current_page: 1,
        total_pages: 1
      },
      loading: false,
      filteredData: [],
    }
  },
  computed: {

    // Sorted data
    sortedData() {
      let result = [...this.filteredData];

      if (this.sortColumn) {
        result.sort((a, b) => {
          let valA = a[this.sortColumn];
          let valB = b[this.sortColumn];

          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';

          if (this.sortColumn === 'id') {
            valA = parseInt(String(valA).replace('#', '')) || 0;
            valB = parseInt(String(valB).replace('#', '')) || 0;
          }

          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();

          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return result;
    },
  },
  mounted() { //doc read
    // alert(localStorage.getItem('user_token'));
    this.fetchList()

    this.$nextTick(() => {
      setTimeout(() => {
        this.initFilters();
      }, 100);
    });
  },
  methods: {
    openCreateModal(ref) {
      this.$refs[ref].showModal()

    },

    closeCreateModal(ref) {
      this.$refs[ref].closeModal()
    },

    async onCreated() {
      this.pagination.current_page = 1
      await this.fetchList()
    },

    async fetchList() {
      this.loading = true

      const result = await form_api_submit({
        url: 'template/list',
        method: 'GET',
        data: {
          page: this.pagination.current_page,
        },
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        console.log(result);
        this.templates = result.data.list
        this.pagination = result.data.pagination
      }

      this.loading = false
    },

    changePage(page) {
      if (page < 1 || page > this.pagination.total_pages) return
      this.pagination.current_page = page
      // alert(this.pagination.current_page);
      this.fetchList()
    },
    initFilters() {
      if (typeof $ === "undefined" || typeof GenericFilterManager === "undefined") return;

      this.filterManager = new GenericFilterManager({
        containerId: "filtersBar",
        filters: [
          {
            key: "id",
            label: "ID",
            type: "input",
            placeholder: "Filter by ID"
          },
          {
            key: "name",
            label: "Name",
            type: "input",
            placeholder: "Filter by Name"
          },
          {
            key: "role",
            label: "Role",
            type: "checkbox",
            options: [
              { value: "admin", label: "Admin" },
              { value: "manager", label: "Manager" },
              { value: "user", label: "User" }
            ]
          }
        ],
        onFilterChange: (filters) => {
          this.applyFilters(filters);
        }
      });
    },

    applyFilters(activeFilters) {
      let result = [...this.templates];

      // For input type (string value)
      if (activeFilters.id) {
        result = result.filter(item =>
          item.id.toLowerCase().includes(activeFilters.id.toLowerCase())
        );
      }

      // For checkbox type (array value)
      if (activeFilters.role?.length) {
        result = result.filter(item =>
          activeFilters.role.includes(item.role.toLowerCase())
        );
      }

      this.filteredData = result;
    },
     resetPagination() {
      this.pagination.current_page = 1;
      this.fetchList();
    },
    resetAllFilters() {
      if (this.filterManager) {
        this.filterManager.clearAllFilters();
      }
      this.filteredData = [...this.templates];
      this.sortColumn = 'name';
      this.sortOrder = 'asc';
      this.resetPagination();
    },
    // Sorting method
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
      this.resetPagination(); // Reset to first page when sorting changes
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up text-primary' : 'fas fa-sort-down text-primary';
    },
  }
}
</script>

<style scoped>
/* .card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
} */

.page-link {
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #667eea;
  border-color: #667eea;
}

img {
  object-fit: cover;
}
</style>